<template>
  <div class="content-container">
    <div class="order-info">
      <div class="info-item">客户名称: {{ orderReady.name }}</div>
      <div class="info-item">手机号: {{ orderReady.mobile }}</div>
      <div class="info-item">身份证: {{ orderReady.idCard }}</div>
      <div class="info-item">银行卡号: {{ orderReady.bankNo }}</div>
      <div class="info-item">审核结果报告: <a :href="orderReady.examineUrl"
                                              target="_blank"> 点击查看</a></div>
      <div class="info-item">报告单号: {{ orderReady.examineNo }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderReady",
  props: {
    orderReady: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.content-container {
  max-height: calc(100vh - 250px);
  min-height: 300px;
  overflow-y: auto;
}
.order-info {
  display: flex;
  flex-wrap: wrap;
}

.info-item {
  flex-basis: calc(33.333% - 20px);
  box-sizing: border-box;
  min-width: 200px;
  margin: 10px;
}
</style>
